/**
 * CSV export utility — single helper used by every table that exposes
 * a "Download CSV" button. Always uses the *currently-visible*
 * (filtered) rows so what the user sees is what they get.
 *
 *   exportRowsToCsv(rows, [
 *     { header: "Agent",   accessor: (r) => r.name },
 *     { header: "Burn/mo", accessor: (r) => r.monthlyCostAud, formatter: aud },
 *   ], "agents-acme-bank-2026-02-12.csv");
 *
 * Values are RFC-4180 escaped (double-quote any field containing a
 * comma, quote, or newline; double existing quotes).
 */

function escapeCsv(value) {
  if (value === null || value === undefined) return "";
  const s = String(value);
  if (s.includes('"') || s.includes(",") || s.includes("\n") || s.includes("\r")) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}

function rowToLine(row, columns) {
  return columns
    .map((c) => {
      const raw = typeof c.accessor === "function" ? c.accessor(row) : row[c.accessor];
      const formatted = c.formatter ? c.formatter(raw, row) : raw;
      return escapeCsv(formatted);
    })
    .join(",");
}

export function exportRowsToCsv(rows, columns, filename = "export.csv") {
  if (!rows || rows.length === 0) {
    // Still emit a file with the header line so the user gets feedback.
    rows = [];
  }
  const headerLine = columns.map((c) => escapeCsv(c.header)).join(",");
  const body = rows.map((r) => rowToLine(r, columns)).join("\n");
  const csv = `${headerLine}\n${body}\n`;
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.style.display = "none";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

// Convenience: build a date-stamped filename like
//   "agents-acme-bank-2026-02-12.csv"
export function csvFilename(scope, tenantId) {
  const today = new Date().toISOString().slice(0, 10);
  const t = tenantId ? `-${tenantId}` : "";
  return `${scope}${t}-${today}.csv`;
}
